import React from 'react';
export function ForYou() {
  const checks = [{
    icon: '❌',
    text: 'Estás cansado de pagar',
    strong: '$3.500 por una barrita de quiosco',
    rest: 'que sabe a cartón y se te deshace en la mano'
  }, {
    icon: '❌',
    text: 'Buscás mantener la proteína alta, pero los suplementos importados',
    strong: 'te hacen imposible llegar a fin de mes',
    rest: ''
  }, {
    icon: '❌',
    text: 'Intentaste hacer barritas caseras y te salió una piedra, porque las recetas de internet',
    strong: 'no dan los gramos exactos ni el truco de la textura',
    rest: ''
  }, {
    icon: '❌',
    text: 'Terminás comiendo arroz con huevo por décima vez porque',
    strong: '"era lo más barato que había"',
    rest: 'y tu progreso en el gym se estanca'
  }, {
    icon: '✅',
    text: 'Querés un sistema simple, con ingredientes de Coto o Carrefour, que te dé',
    strong: '20g de proteína real por menos de $800 por porción',
    rest: ''
  }];
  return <section className="bg-white py-20 px-5" data-id="element-47">
      <div className="max-w-[780px] mx-auto" data-id="element-48">
        <div className="w-12 h-1 bg-gradient-to-r from-[#15803D] to-[#22C55E] rounded-sm mx-auto mb-5" data-id="element-49" />

        <h2 className="font-montserrat text-[clamp(22px,3.5vw,32px)] font-extrabold text-center mb-[10px] text-[#0F172A] tracking-tight leading-[1.2]" data-id="element-50">
          Este sistema es para vos si...
        </h2>

        <p className="text-center text-[#475569] text-[15px] mb-10" data-id="element-51">
          Marcate en esta lista y vas a entender por qué esto cambia todo
        </p>

        <ul className="list-none max-w-[620px] mx-auto" data-id="element-52">
          {checks.map((item, idx) => <li key={idx} className="flex items-start gap-4 text-base py-4 border-b border-[#E2E8F0] leading-[1.55] text-[#475569] transition-colors duration-[0.25s] hover:text-[#0F172A] last:border-b-0" data-id="element-53">
              <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-54">{item.icon}</span>
              <span data-id="element-55">
                {item.text}{' '}
                <strong className="text-[#0F172A] font-semibold" data-id="element-56">
                  {item.strong}
                </strong>{' '}
                {item.rest}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}